export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10420.64a24b0a.jpg";